import { render, staticRenderFns } from "./FunctionMenu.vue?vue&type=template&id=36bc919c&scoped=true&lang=pug"
import script from "./FunctionMenu.vue?vue&type=script&lang=ts"
export * from "./FunctionMenu.vue?vue&type=script&lang=ts"
import style0 from "./FunctionMenu.vue?vue&type=style&index=0&id=36bc919c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bc919c",
  null
  
)

export default component.exports